import React from "react";
import { useDiscovery } from "./DiscoveryContext";

const DiscoveryPrompt = ({ onStart }) => {
  const { preferences, markPromptAsSeen, setDiscoveryStep } = useDiscovery();

  if (
    !preferences ||
    preferences.hasSeenDiscoveryPrompt ||
    preferences.discoveryStep > 0
  ) {
    return null;
  }

  const handleStart = () => {
    setDiscoveryStep(1);
    onStart();
  };

  const handleDismiss = () => {
    markPromptAsSeen();
  };

  const progress = 0; // Current step is 0 since this is the prompt

  return (
    <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 rounded-2xl shadow-xl p-6 mb-2 border border-white/10 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute -top-24 -right-24 w-48 h-48 bg-white/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-purple-400/20 rounded-full blur-3xl" />

      <div className="flex flex-col md:flex-row items-center justify-between gap-6 relative z-10">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 bg-white/20 rounded text-[10px] font-bold text-white uppercase tracking-wider">
              Get Started
            </span>
            <h3 className="text-xl font-bold text-white">
              🎯 Level Up Your Instagram Sales!
            </h3>
          </div>
          <p className="text-white/90 mb-6 max-w-2xl">
            Set up automated DMs in 2 minutes and start selling directly from
            your posts. We'll guide you through the process step-by-step.
          </p>
          <div className="flex items-center gap-4">
            <div className="flex-1 bg-white/20 rounded-full h-2.5 max-w-[240px]">
              <div
                className="bg-white rounded-full h-2.5 transition-all duration-700 ease-out shadow-[0_0_10px_rgba(255,255,255,0.5)]"
                style={{ width: `${progress}%` }}
              />
            </div>
            <span className="text-sm text-white font-bold">{progress}%</span>
            <span className="text-xs text-white/70 italic">
              Almost ready to blast off! 🚀
            </span>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <button
            onClick={handleDismiss}
            className="text-white/70 hover:text-white text-sm font-semibold transition-colors px-4 py-2"
          >
            Maybe Later
          </button>
          <button
            onClick={handleStart}
            className="bg-white text-indigo-600 px-8 py-3 rounded-xl font-bold hover:bg-gray-50 transition-all transform hover:scale-105 active:scale-95 shadow-lg flex items-center gap-2"
          >
            🚀 Start Journey
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscoveryPrompt;
